import http from '../jslibs/axios/http';

//财务管理 提现列表
export const withdrawList = data => (http.get('/v1/cms/UserWithdrawal', data));

//财务管理 提现详情
export const withdrawDetail = uuid => (http.get(`/v1/cms/UserWithdrawal/${uuid}`));

//财务管理 改变提现状态
export const withdrawStatusChange= (data, uuid) => (http.put(`/v1/cms/UserWithdrawal/${uuid}`, data));

//财务管理 平台流水
export const platformFlow = data => (http.get('/v1/cms/PlatformTradingRecode', data));

